import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { CSpinner } from '@coreui/react'
import './scss/style.scss'

const loading = (
  <CSpinner
    className="position-absolute top-50 start-50"
    variant="grow"
    style={{ width: '5rem', height: '5rem' }}
  />
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
const ViewSurvey = React.lazy(() => import('./views/pages/view-survey/ViewSurvey'))
const AnswerSurvey = React.lazy(() => import('./views/pages/answer-survey/AnswerSurvey'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route
              exact
              path="/survey/view/:surveyId"
              name="View Survey"
              element={<ViewSurvey />}
            />
            <Route
              exact
              path="/survey/answer/:surveyId"
              name="Answer Survey"
              element={<AnswerSurvey />}
            />
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
